/*
  Linear Bar accessibility helpers (WCAG 2.1 AA)
  Built by Byld Commerce. Loaded with defer from layout/theme.liquid.
  Adds keyboard support and screen reader labels to the theme's custom
  widgets. It only adds attributes and listeners; it never changes what a
  click does, so the existing theme scripts keep working as before.
*/
(function () {
  'use strict';

  var d = document;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function each(selector, fn, root) {
    Array.prototype.forEach.call((root || d).querySelectorAll(selector), fn);
  }

  function isActivateKey(e) {
    return e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar';
  }

  // Make a non-button element (div, span, li) work like a button for the keyboard
  function makeButton(el, label) {
    el.setAttribute('role', 'button');
    if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '0');
    if (label) el.setAttribute('aria-label', label);
    if (el.getAttribute('data-lb-key')) return;
    el.setAttribute('data-lb-key', '1');
    el.addEventListener('keydown', function (e) {
      if (isActivateKey(e)) {
        e.preventDefault();
        el.click();
      }
    });
  }

  function watchClass(el, fn) {
    if (!window.MutationObserver) return;
    new MutationObserver(fn).observe(el, { attributes: true, attributeFilter: ['class', 'style'] });
  }

  /* ---------- FAQ accordions (.acc / .acc-head / .acc-content) ---------- */
  var accCount = 0;
  function initAccordions() {
    each('.acc', function (acc) {
      var head = acc.querySelector('.acc-head');
      var body = acc.querySelector('.acc-content');
      if (!head || head.getAttribute('data-lb-acc')) return;
      head.setAttribute('data-lb-acc', '1');
      if (body && !body.id) body.id = 'lbAccPanel' + (++accCount);
      makeButton(head);
      if (body) head.setAttribute('aria-controls', body.id);
      var sync = function () {
        head.setAttribute('aria-expanded', acc.classList.contains('active') ? 'true' : 'false');
      };
      sync();
      watchClass(acc, sync);
    });
  }

  /* ---------- Homepage product tabs (#tabs-nav li.btnn) ---------- */
  function initTabs() {
    each('#tabs-nav', function (list) {
      if (list.getAttribute('data-lb-tabs')) return;
      // The theme hides these tabs at the moment. Only add tab roles when they show.
      if (!list.getClientRects().length) return;
      list.setAttribute('data-lb-tabs', '1');
      list.setAttribute('role', 'tablist');
      var tabs = Array.prototype.slice.call(list.querySelectorAll('li.btnn'));
      var sync = function () {
        tabs.forEach(function (t) {
          var on = t.classList.contains('active');
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
        });
      };
      tabs.forEach(function (tab, i) {
        tab.setAttribute('role', 'tab');
        if (!tab.id) tab.id = 'lbTab' + (i + 1);
        var panel = d.getElementById('tab' + (i + 1));
        if (panel) {
          tab.setAttribute('aria-controls', panel.id);
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', tab.id);
          panel.removeAttribute('aria-label');
        }
        tab.addEventListener('keydown', function (e) {
          var j = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') j = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') j = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') j = 0;
          else if (e.key === 'End') j = tabs.length - 1;
          else if (isActivateKey(e)) { e.preventDefault(); tab.click(); return; }
          if (j !== null) {
            e.preventDefault();
            tabs[j].click();
            tabs[j].focus();
          }
        });
        watchClass(tab, sync);
      });
      sync();
    });
  }

  /* ---------- Buy box radios ---------- */
  function initBuyBox() {
    // The selected pack is shown with a class only. Tell screen readers too.
    each('.packvariantwrappper', function (group) {
      if (group.querySelector('input[type="radio"]:checked')) return;
      var active = group.querySelector('.packvariantbox.active > input[type="radio"]');
      if (active) active.checked = true;
    });
    // Size radios on the apparel product page
    each('.sizevar ul', function (group) {
      if (group.querySelector('input[type="radio"]:checked')) return;
      var active = group.querySelector('li.active > input[type="radio"]');
      if (active) active.checked = true;
    });
    // Quantity minus / plus on the apparel product page
    each('.qtybox .btnqty', function (btn) {
      makeButton(btn, btn.classList.contains('qtyminus') ? 'Decrease quantity' : 'Increase quantity');
    });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var toggler = d.querySelector('.navbar-toggler');
    var nav = d.getElementById('lbMainNav') || d.querySelector('.navbar-collapse');
    if (toggler && nav && !toggler.getAttribute('data-lb-nav')) {
      toggler.setAttribute('data-lb-nav', '1');
      if (!toggler.getAttribute('aria-label')) toggler.setAttribute('aria-label', 'Menu');
      var syncNav = function () {
        var open = window.getComputedStyle(nav).display !== 'none';
        toggler.setAttribute('aria-expanded', open ? 'true' : 'false');
      };
      syncNav();
      toggler.addEventListener('click', function () {
        // the theme opens the menu with a 400ms slide
        setTimeout(syncNav, 450);
      });
    }

    each('.navbar-nav .dropdown-toggle', function (t) {
      if (t.getAttribute('data-lb-dd')) return;
      t.setAttribute('data-lb-dd', '1');
      var li = t.parentElement;
      var link = li && li.querySelector('a');
      var name = link ? link.textContent.trim() : '';
      makeButton(t, name ? 'Show ' + name + ' menu' : 'Show submenu');
      var svg = t.querySelector('svg');
      if (svg) { svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('focusable', 'false'); }
      var sync = function () {
        t.setAttribute('aria-expanded', li.classList.contains('activenav') ? 'true' : 'false');
      };
      sync();
      watchClass(li, sync);
    });
  }

  /* ---------- Customer videos (play on click) ---------- */
  function initVideos() {
    each('.videoswiper', function (sw) {
      var n = 0;
      each('.swiper-slide', function (slide) {
        var video = slide.querySelector('video');
        if (!video) return;
        if (slide.classList.contains('swiper-slide-duplicate')) {
          // copies Swiper makes for looping: keep them out of the keyboard order
          slide.setAttribute('aria-hidden', 'true');
          slide.setAttribute('tabindex', '-1');
          return;
        }
        n++;
        if (slide.getAttribute('data-lb-video')) return;
        slide.setAttribute('data-lb-video', String(n));
        var label = function () {
          return (video.paused ? 'Play' : 'Pause') + ' customer video ' + slide.getAttribute('data-lb-video');
        };
        makeButton(slide, label());
        video.setAttribute('aria-hidden', 'true');
        video.addEventListener('play', function () { slide.setAttribute('aria-label', label()); });
        video.addEventListener('pause', function () { slide.setAttribute('aria-label', label()); });
      }, sw);
    });
  }

  /* ---------- Pause buttons for things that move on their own (2.2.2) ---------- */
  var ICON_PAUSE = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><rect x="2" y="1" width="3" height="10" fill="currentColor"/><rect x="7" y="1" width="3" height="10" fill="currentColor"/></svg>';
  var ICON_PLAY = '<svg viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M3 1l8 5-8 5z" fill="currentColor"/></svg>';

  function addMotionToggle(host, what, pause, play, startPaused) {
    if (host.querySelector(':scope > .lb-motion-toggle')) return;
    var btn = d.createElement('button');
    btn.type = 'button';
    btn.className = 'lb-motion-toggle';
    var paused = false;
    var render = function () {
      btn.innerHTML = paused ? ICON_PLAY : ICON_PAUSE;
      btn.setAttribute('aria-label', (paused ? 'Play ' : 'Pause ') + what);
    };
    btn.addEventListener('click', function () {
      paused = !paused;
      if (paused) pause(); else play();
      render();
    });
    if (startPaused) { paused = true; pause(); }
    render();
    host.appendChild(btn);
  }

  function initMotion() {
    // Scrolling text strips
    each('.main-maruee', function (strip) {
      addMotionToggle(strip, 'scrolling text',
        function () { strip.classList.add('lb-paused'); },
        function () { strip.classList.remove('lb-paused'); },
        reduceMotion);
    });

    // Logo strip ("As seen on") and the About page photo strip
    each('.partnerslide, .exitslider', function (el) {
      var sw = el.swiper;
      if (!sw || !sw.autoplay) return;
      var host = el.closest('.parrtnerouter') || el.parentElement;
      if (!host.classList.contains('parrtnerouter')) host.classList.add('lb-motion-host');
      addMotionToggle(host, el.classList.contains('partnerslide') ? 'moving logos' : 'moving photos',
        function () { sw.autoplay.stop(); },
        function () { sw.autoplay.start(); },
        reduceMotion);
    });

    // Any other Swiper that slides by itself: stop it for reduced motion users
    if (reduceMotion) {
      each('.swiper', function (el) {
        if (el.swiper && el.swiper.autoplay && el.swiper.autoplay.running) el.swiper.autoplay.stop();
      });
    }
  }

  /* ---------- Images with placeholder alt text ---------- */
  // Words like "Vector" or "Slide" tell a screen reader user nothing.
  // These images are decoration, so they get an empty alt.
  var JUNK_ALT = ['vector', 'top vector', 'bottom vector', 'slide', 'collage', 'banner', 'image', 'img', 'icon'];
  function cleanAlts() {
    each('img[alt]', function (img) {
      if (img.closest('a, button')) return; // an image inside a link may be its only name
      var a = (img.getAttribute('alt') || '').trim().toLowerCase();
      if (a && JUNK_ALT.indexOf(a) !== -1) img.setAttribute('alt', '');
    });
  }

  function init() {
    try { initAccordions(); } catch (e) {}
    try { initTabs(); } catch (e) {}
    try { initBuyBox(); } catch (e) {}
    try { initHeader(); } catch (e) {}
    try { initVideos(); } catch (e) {}
    try { initMotion(); } catch (e) {}
    try { cleanAlts(); } catch (e) {}
  }

  // The theme builds its sliders when jQuery is ready, which is just after
  // DOMContentLoaded. Run once after that, and again on full load. Every step
  // is safe to run twice.
  function start() {
    setTimeout(init, 60);
    window.addEventListener('load', function () { setTimeout(init, 60); });
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start);
  else start();
})();
